<template>
    <div class="doc-container">
        <div class="left">
            <div class="top-content">
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 100px;">Doc ID</th>
                                <th>WO Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in column_data" :key="index">
                                <td>{{ item[0] }}</td>
                                <td>
                                    <input
                                    ref="woInputs"
                                    style="width: 100%;"
                                    v-model="item[1]"
                                    type="text"
                                    @focus="selectRow(index)"
                                    @input="filterResults(item[1])"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="textbox-wrapper">
                    <div v-if="activeIndex !== null" class="textbox" :style="{ '--pointer-top': pointerTop + 'px' }">
                        <table>
                            <tr v-for="suggestion in suggestions">
                                <td v-for="item in suggestion">{{ item }}</td>
                            </tr>
                        </table>
                    </div>
                    <div v-else class="emptybox"></div>
                </div>
            </div>
            <div class="bottom-button">
                <p>Remaining Documents:<strong> {{remaining}}</strong></p>
                <button @click="submit">Submit</button>
            </div>
        </div>
        <div class="right">
            <document 
                v-if="activeIndex !== null" 
                :dir="'doc_'+parseInt(column_data[activeIndex][0])+'.jpg'" 
                :doc_id="column_data[activeIndex][0].toString()"
                :enforceMax="'105px'"
            ></document>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data(){
		return {
            pageid:PAGES.ASSIGN_DOCUMENT_WO_PAGE,
            column_data: [],
            activeIndex: null,
            suggestions: [],
            lastUpdate: 0,
            pointerTop: 0,
            remaining:0,
		}
	},
	async created () {
        this.search();
	},
    mounted() {
        document.addEventListener('mousedown', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    },
	methods:{
		selectRow(index) {
            this.activeIndex = index;
            this.filterResults(this.column_data[this.activeIndex][1]);

            this.$nextTick(() => {
                const inputEl = this.$refs.woInputs[index];
                if (inputEl) {
                    inputEl.focus();
                    const containerOffset = inputEl.closest('.left').getBoundingClientRect().top;
                    const inputOffset = inputEl.getBoundingClientRect().top;
                    this.pointerTop = inputOffset - containerOffset + inputEl.offsetHeight / 2 - 30;
                }
            });
        },
        filterResults(content) {
            let timestamp = new Date().getTime()

            api.postData(
                {
                    type:"suggestion",
                    data:{
                        index:66, //joborders
                        data:[content]
                    },
                    timestamp:timestamp,
                }
            ).then((res) => {
                if(res.data.timestamp > this.lastUpdate){
                    this.lastUpdate = res.data.timestamp;
                    this.suggestions = res.data.data.column_data;
                }
            });
        },
        handleClickOutside(event) {
            const inputEls = this.$refs.woInputs;
            const imageArea = this.$el.querySelector('.right');

            const clickedInput = Array.isArray(inputEls) && inputEls.some(input => input && input.contains(event.target));
            const clickedImage = imageArea && imageArea.contains(event.target);

            if (!clickedInput && !clickedImage) {
                this.activeIndex = null;
            } else if (this.activeIndex !== null && clickedImage) {
                setTimeout(() => {
                    const input = this.$refs.woInputs[this.activeIndex];
                    if (input) input.focus();
                }, 0);
            }
        },
        search(){
			api.postData({
				type:"search",
				data:{
					pageid:this.pageid,
				}
			}).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null && res.data.data.column_data[0].length>0) {
                    this.column_data = res.data.data.column_data;
                    setTimeout(() => {
                        const inputs = this.$refs.woInputs;
                        if (Array.isArray(inputs) && inputs[0]) {
                            inputs[0].focus();
                        }
                    }, 0);

                    this.remaining = res.data.data.results;
				}else {
                    this.column_data = []
                }
			})
        },
        submit() {
            api.postData({
				type:"insert",
				data:{
					pageid:this.pageid,
                    data:this.column_data
				}
			}).then((res) => {
				this.search();
			})
        }
	},
}
</script>

<style scoped>
.doc-container {
    display: flex;
    width: 100%;
    margin:0px;
    padding:0px;
    height: calc(100vh - 50px);
}

.left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #f0f0f0;
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    min-width: 0;
}

.right {
    flex-shrink: 1;
    max-width: 50%;
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
}

.table-wrapper {
    flex: 0 0 30%;
    overflow: auto;
}

.textbox-wrapper {
    flex: 0 0 70%;
    padding-left: 15px;
    display: flex;
    align-items: flex-start;
    position: relative;
}

.textbox, .emptybox {
    border: 1px solid #ccc;
    background-color: #fff;
    padding: 10px;
    min-height: 35px;
    width: 100%;
    position: relative;
    margin-top: 4px;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.textbox::before {
    content: '';
    position: absolute;
    top: var(--pointer-top, 10px);
    left: -20px;
    width: 20px;
    height: 30px;
    background-color: #fff;
    clip-path: polygon(100% 0, 0 30%, 0 70%, 100% 100%);
    filter: drop-shadow(-1px 0px 1px rgba(0,0,0,0.1));
}

.top-content {
    display:flex;
    flex-grow: 1;
    overflow: auto;
    flex-direction: row;
}

.bottom-button {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  height:30px;
}

.bottom-button p {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  height:30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom-button button {
  justify-self: center;
  height:30px;
  width: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/edit/Assign_Document_WO.vue